<template>
  <div v-if="product.powerReviewsID">
    <div :id="`pr-reviewsnippet-${product.powerReviewsID}`" class="pr-reviewsnippet pr-reviewsnippet--min-height">
      <div data-pr-placeholder />
    </div>
  </div>
</template>
<script>
export default {
  name: 'PdpReviewsSummary',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped lang="scss">
// setting a min height on the Power Reviews Snippet element so that the content doesn't shift on page load
// This plus the placeholder div are the recommendations to avoid content shift in the Power Reviews docs
// https://help.powerreviews.com/Content/Resources-PWR/Google-SEO-Updates-Page-Experience.htm?mkt_tok=NjUzLURNWi0xMDYAAAF9BlqXtjUDNpLPGsro37_Y8jCs_Q6lX8HJp_ZgUUHIz3N0fLkMBYESBVtuomw6OU73n7-NCwTseXm-stgtrVMU-I-0Dm1agY9unAkVKnW7SIE#Reduce
.pr-reviewsnippet--min-height {
  min-height: 22px;
}
</style>
